
const keyify = (key: string = '') =>
  (key || '')
    .replace(/\s/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .toLowerCase();

export default keyify;